enum DocuSignEnvelopeStatuses {
  Completed = 'completed',
  Correct = 'correct',
  Created = 'created',
  Declined = 'declined',
  Delivered = 'delivered',
  Sent = 'sent',
  Signed = 'signed',
  Template = 'template',
  Voided = 'voided',
}
export default DocuSignEnvelopeStatuses;
export type VerifyDocuSignEnvelopeStatuses = Utils.VerifyExtends<
  Model.Enum.DocuSignEnvelopeStatuses,
  Utils.ValueOf<typeof DocuSignEnvelopeStatuses>
>;
